define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/xml",
	"./_Report"
], function(declare, _, xml, _Report) {

	return declare(_Report, {
		// FIX: this is hopefully temporary, the problem being that the GroupNodes store does not have method to get list of all URLs to report on ... yet;
		// we need ValuesByXML to return refs rather than just counts
		supportsGroups: false,

		_internalAttributes: {
			"Node Name": 1,
			"Node Type": 1,
			Children: 1,
			Parent: 1,
			__Column__: 1,
			__Index__: 1,
			__Name__: 1,
			__Report__: 1
		},

		// String: type of node to create for calculating dynamic rollups
		type: null,

		constructor: function(type) {
			this.type = type;
		},

		generate: function(qr, writer) {
			// summary: write operations to generate report and return deferred that resolves to calculated report nodes
			const store = this._getReportStore(qr);

			writer.createNode(qr.url, this.type)
				.changeAttribute("Parent", xml.ATTR_REF, qr.parentUrl)
				.changeAttribute("Children", xml.ATTR_REFLIST, store.getResults())
				.disableAttributeExp("Parent")
				.disableAttributeExp("Children");

			return () => { };
		}
	});
});